import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { hasAtLeastOneField } from '../shared/refines';
import { TicketGroupInputValidationSchema } from '../event-page/create';
import {
  TICKET_GROUP_TRIGGER_ID_DESCRIPTION,
  TicketGroupEventIdInputSchema,
  TicketGroupIdInputSchema,
  TicketGroupPathParamsValidationSchema,
} from './params';

export const UpdateTicketGroupParamsValidationSchema = TicketGroupPathParamsValidationSchema;

export const UpdateTicketGroupRequestValidationSchema = TicketGroupInputValidationSchema.omit({
  key: true,
  triggerTicketGroupId: true,
  ticketTypes: true,
})
  .partial()
  .extend({
    triggerTicketGroupId: ObjectIdStringValidationSchema.nullish().openapi({
      description: "Ticket group ID that triggers this group's availability.",
      example: '507f1f77bcf86cd799439012',
    }),
  })
  .openapi('UpdateTicketGroupRequest');

const ticketGroupUpdateToolShape = {
  ...UpdateTicketGroupRequestValidationSchema.shape,
  triggerTicketGroupId: ObjectIdStringValidationSchema.nullish().meta({
    description: `${TICKET_GROUP_TRIGGER_ID_DESCRIPTION} Pass null to remove the trigger.`,
  }),
};

export const TICKET_GROUP_UPDATE_FIELDS = Object.keys(ticketGroupUpdateToolShape) as ReadonlyArray<
  keyof typeof ticketGroupUpdateToolShape
>;

export const UpdateTicketGroupInputValidationSchema = z
  .object({
    pageId: TicketGroupEventIdInputSchema,
    ticketGroupId: TicketGroupIdInputSchema,
    ...ticketGroupUpdateToolShape,
  })
  .refine(
    value => {
      const { pageId: _pageId, ticketGroupId: _ticketGroupId, ...changes } = value;
      return hasAtLeastOneField(changes);
    },
    { message: 'At least one ticket group property to update must be provided.' },
  );

export type UpdateTicketGroupInput = z.infer<typeof UpdateTicketGroupInputValidationSchema>;
